"use client";

import { c as _c } from "react/compiler-runtime";
import { usePrefetchMemesQuickVote } from "@/hooks/usePrefetchMemesQuickVote";
import { useCallback, useRef, useState } from "react";
type UseMemesQuickVoteDialogControllerResult = {
  readonly closeQuickVote: () => void;
  readonly isQuickVoteOpen: boolean;
  readonly openQuickVote: () => void;
  readonly prefetchQuickVote: () => void;
  readonly quickVoteSessionId: number;
};
export const useMemesQuickVoteDialogController = () => {
  const $ = _c(10);
  const prefetchMemesQuickVote = usePrefetchMemesQuickVote();
  const [isQuickVoteOpen, setIsQuickVoteOpen] = useState(false);
  const [quickVoteSessionId, setQuickVoteSessionId] = useState(0);
  const lastIssuedSessionIdRef = useRef(0);
  const reservedSessionIdRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = new Set();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const prefetchedSessionIdsRef = useRef(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      if (reservedSessionIdRef.current !== null) {
        return reservedSessionIdRef.current;
      }
      const nextSessionId = lastIssuedSessionIdRef.current + 1;
      reservedSessionIdRef.current = nextSessionId;
      return nextSessionId;
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const reserveSessionId = t1;
  let t2;
  if ($[2] !== prefetchMemesQuickVote) {
    t2 = () => {
      const sessionId = reserveSessionId();
      if (prefetchedSessionIdsRef.current.has(sessionId)) {
        return;
      }
      prefetchedSessionIdsRef.current.add(sessionId);
      prefetchMemesQuickVote(sessionId);
    };
    $[2] = prefetchMemesQuickVote;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const prefetchQuickVote = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      const sessionId_0 = reservedSessionIdRef.current ?? lastIssuedSessionIdRef.current + 1;
      lastIssuedSessionIdRef.current = sessionId_0;
      reservedSessionIdRef.current = null;
      setQuickVoteSessionId(sessionId_0);
      setIsQuickVoteOpen(true);
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const openQuickVote = t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setIsQuickVoteOpen(false);
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const closeQuickVote = t4;
  let t5;
  if ($[6] !== isQuickVoteOpen || $[7] !== prefetchQuickVote || $[8] !== quickVoteSessionId) {
    t5 = {
      closeQuickVote,
      isQuickVoteOpen,
      openQuickVote,
      prefetchQuickVote,
      quickVoteSessionId
    };
    $[6] = isQuickVoteOpen;
    $[7] = prefetchQuickVote;
    $[8] = quickVoteSessionId;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};